export const MARKUP_BUNDLE_LIST_ACTION = "MARKUP_BUNDLE_LIST_ACTION";
export const MARKUP_BUNDLE_ALL_LIST_ACTION = "MARKUP_BUNDLE_ALL_LIST_ACTION";
export const MARKUP_BUNDLE_LIST_SUCCESS = "MARKUP_BUNDLE_LIST_SUCCESS";
export const MARKUP_BUNDLE_LIST_FAIL = "MARKUP_BUNDLE_LIST_SUCCESS";

export const MARKUP_BUNDLE_DETAIL_ACTION = "MARKUP_BUNDLE_DETAIL_ACTION";
export const MARKUP_BUNDLE_DETAIL_SUCCESS = "MARKUP_BUNDLE_DETAIL_SUCCESS";

export const MARKUP_BUNDLE_DETAIL_CREATE_ACTION = "MARKUP_BUNDLE_DETAIL_CREATE_ACTION";
export const MARKUP_BUNDLE_DETAIL_UPDATE_ACTION = "MARKUP_BUNDLE_DETAIL_UPDATE_ACTION";
export const MARKUP_BUNDLE_DETAIL_DELETE_ACTION = "MARKUP_BUNDLE_DETAIL_DELETE_ACTION";
export const MARKUP_BUNDLE_DETAIL_FAIL = "MARKUP_BUNDLE_DETAIL_FAIL";
export const MARKUP_BUNDLE_UPDATE_FAIL = "MARKUP_BUNDLE_UPDATE_FAIL";